<template>
  <b-modal
    @hide="closeModel"
    :id="`assign-vehicle-model-${trip?._id}`"
    size="lg"
    :modal-class="['change-modal-container']"
  >
    <base-spinner v-if="data_loading" />
    <div v-else class="p-3">
      <div>
        <b-alert :show="error && error.length ? true : false" variant="danger">
          <div v-if="Array.isArray(error)">
            <div class="d-flex flex-column my-1" v-for="(error_text, index) in error" :key="index">
              {{ error_text }}
            </div>
          </div>
          <div v-else>
            <div v-html="error || '&nbsp;'"></div>
          </div>
        </b-alert>

        <div class="d-flex justify-content-between align-items-center my-4">
          <div class="assign-section-title">{{ $t('assign-vehicle') }}</div>
          <img
            :src="require('@/assets/images/icons/close-icon.svg')"
            alt=""
            class="cursor-pointer"
            @click="closeModel()"
          />
        </div>
        <hr />
        <div class="block-lg mb-3">
          <ChangeVehicleList
            :trip="trip"
            @selectVehicle="selectVehicle"
            :selectedVehicleId="selectedVehicleId"
            :selectedDriverId="selectedDriverId"
          />
        </div>
      </div>
      <div class="modal-action-container d-flex align-items-center justify-content-end">
        <div>
          <base-button
            variant="primary"
            :loading="loading"
            id="change-vehicle-search-btn-save"
            @click="submit"
            :disabled="!selectedVehicleId"
          >
            {{ $t('assign') }}
          </base-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ChangeVehicleList from './ChangeVehicleList.vue'

export default {
  name: 'assign-vehicle-model',
  components: { ChangeVehicleList },
  props: ['trip', 'selectedDriverId'],
  emits: ['selectedVehicle'],
  data() {
    return {
      data_loading: false,
      loading: false,
      error: null,
      selectedVehicleId: null,
      selectedVehicle: null,
    }
  },
  methods: {
    selectVehicle(item) {
      this.selectedVehicleId = (item && item.id) || null
      this.selectedVehicle = item ? item : null
    },
    submit() {
      this.$emit('selectedVehicle', this.selectedVehicle.id)
      this.closeModel()
    },

    closeModel() {
      this.error = null
      this.$bvModal.hide(`assign-vehicle-model-${this.trip?._id}`)
    },
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/operations.json'),
      ar: require('@/services/i18n/locales/ar/operations.json'),
    },
  },
}
</script>
